export default __webpack_public_path__ + "static/media/ic-quantity-1k.0a22db7c.svg";